import { render } from "./QBadge.vue?vue&type=template&id=3e572518&scoped=true"
import script from "./QBadge.vue?vue&type=script&lang=js"
export * from "./QBadge.vue?vue&type=script&lang=js"

import "./QBadge.vue?vue&type=style&index=0&id=3e572518&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e572518"]])

export default __exports__